module.exports = __webpack_public_path__ + "img/laporan.24ca1a3c.png";